import Routes from '../constants/routes';

const isLinkToAnotherWorld = (path = ''): boolean => !path.startsWith(Routes.HOME.path);

export default isLinkToAnotherWorld;
